function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { useRefCallback, useToggle } from '@bydesign-ui/hooks';
import { useLocale } from '@byte-design/config';
import { RcSelectProvider, useCreateSelect } from '../../hooks/select';
import { SelectBase } from './components/SelectBase';
import { Option } from './Option';
import { OptionGroup } from './OptionGroup';
export function Select(props) {
  var searchLocale = useLocale('select.search.placeholder');

  var value = props.value,
      disabled = props.disabled,
      readonly = props.readonly,
      ignoreCase = props.ignoreCase,
      filterOption = props.filterOption,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      clearable = props.clearable,
      autoClearSearchValue = props.autoClearSearchValue,
      onHide = props.onHide,
      onDisplayInfoChange = props.onDisplayInfoChange,
      _props$searchPlacehol = props.searchPlaceholder,
      searchPlaceholder = _props$searchPlacehol === void 0 ? searchLocale : _props$searchPlacehol,
      getPopupContainer = props.getPopupContainer,
      _props$filled = props.filled,
      filled = _props$filled === void 0 ? false : _props$filled,
      extra = _objectWithoutProperties(props, ["value", "disabled", "readonly", "ignoreCase", "filterOption", "onChange", "onValueChange", "size", "clearable", "autoClearSearchValue", "onHide", "onDisplayInfoChange", "searchPlaceholder", "getPopupContainer", "filled"]);

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      show = _useToggle2[0],
      handleShow = _useToggle2[1],
      handleHide = _useToggle2[2];

  var onChangeCallback = useRefCallback(onChange);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var onDisplayInfoChangeCallback = useRefCallback(onDisplayInfoChange);
  var handleChange = useCallback(function (newValue, info) {
    onChangeCallback(newValue[0]);
    onValueChangeCallback(newValue[0]);
    onDisplayInfoChangeCallback(info);
  }, []);

  var _useCreateSelect = useCreateSelect({
    value: value == null ? [] : [value],
    onChange: handleChange,
    disabled: disabled,
    readonly: readonly,
    ignoreCase: ignoreCase,
    filterOption: filterOption,
    autoClearSearchValue: autoClearSearchValue,
    multiple: false,
    extraProps: {
      size: size,
      clearable: clearable
    }
  }),
      select = _useCreateSelect.select;

  var onHideCallback = useCallback(function () {
    onHide && onHide();
    handleHide();
  }, [value, onHide]);
  return React.createElement(RcSelectProvider, {
    select: select
  }, React.createElement(SelectBase, Object.assign({}, extra, {
    show: show,
    onShow: handleShow,
    onHide: onHideCallback,
    searchPlaceholder: searchPlaceholder,
    getPopupContainer: getPopupContainer,
    filled: filled
  })));
}
Select.Option = Option;
Select.OptionGroup = OptionGroup;